var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4546 2.21993C11.7962 1.39864 12.9597 1.39864 13.3013 2.21993L15.3174 7.06735C15.4614 7.41358 15.787 7.65015 16.1608 7.68012L21.394 8.09966C22.2807 8.17074 22.6402 9.27725 21.9647 9.85592L17.9775 13.2713C17.6927 13.5153 17.5683 13.8981 17.6554 14.2628L18.8735 19.3695C19.0799 20.2348 18.1386 20.9186 17.3795 20.455L12.8992 17.7184C12.5792 17.5229 12.1767 17.5229 11.8567 17.7184L7.37633 20.455C6.61723 20.9186 5.67598 20.2348 5.88237 19.3695L7.1005 14.2628C7.18751 13.8981 7.06314 13.5153 6.77835 13.2713L2.79121 9.85592C2.11567 9.27725 2.4752 8.17074 3.36185 8.09966L8.59505 7.68012C8.96884 7.65015 9.29445 7.41358 9.43845 7.06735L11.4546 2.21993Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGrey);
export default __webpack_public_path__ + "static/media/star_grey.5035156cb436729d2282f24969b9ad91.svg";
export { ForwardRef as ReactComponent };